import React, { Component, Fragment } from "react";
import MainPage from "../Components/Shared/MainPage";

export default class BrandDigitalCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      UserName: "",
      CompanyName: "",
      Email: "",
      CorporateLogoUrl: "",
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { currentUser } = nextProps;
    if (currentUser && prevState.LastName !== currentUser.LastName) {
      return {
        UserName: `${currentUser.FirstName} ${currentUser.LastName}`,
        CompanyName: currentUser.CompanyName || "",
        Email: currentUser.Email || "",
        CorporateLogoUrl: currentUser.CorporateLogoUrl || "",
      };
    }

    // Return null to indicate no change to state.
    return null;
  }

  render() {
    const { CompanyName, CorporateLogoUrl } = this.state;
    return (
      <MainPage title="Corporate Solutions - Brand Digital Card">
        <div className="px-1 mb-5 px-sm-5 container-fluid">
          <div className="text-center">
            <h5>Business Gifts, Events, Promotions, Employee Recognition</h5>
          </div>
          <hr />
          <h3>'Giving Back'</h3>
          <p>
            <strong>Charity Cards for Business Gifts</strong> -
            <em>branding for your Digital Cards</em>
          </p>
          <p>
            <small><em>Note: You will also be able to upload our specific CSV file of recipients when making the purchase.</em></small>
          </p>
          <p>
            {CompanyName
              ? <Fragment>
                <ul>
                  <li>
                    Your Custom Graphic: {' '}
                    <a href="/Purchase/eCards/?occ_id=54">
                      Create your Digital Card with your own graphic.
                      </a>
                  </li>
                  <li>
                    Your Logo as the Graphic: {' '}
                    <a
                      href="/Purchase/eCards/?occ_id=53"
                      className="smallerText">
                      Create your Digital Card with your corporate logo as the primary image.
                      </a>
                  </li>
                  <li>
                    Primary Graphic plus your Logo: {' '}
                    {CorporateLogoUrl
                      ? <a href="/Purchase/eCards/">
                        Add your logo to the special occasion Digital Card that
                        you have selected.
                        </a>
                      : <Fragment>After you have uploaded your corporate logo in <a href="/Status.aspx">My Account</a>:
                          <ol>
                            <li>Return to <a href="/Purchase/Ecards">purchase 'Digital Card'</a></li>
                            <li>Select the occasion and image</li>
                            <li>Check 'Brand with Logo'</li>
                        </ol>
                      </Fragment>
                    }
                    <br />
                    <small>NOTE:
                    You will be able to have your logo appear in the upper corner of the eGift.
                    <br />
                      Your primary graphic will be selected during the purchase.
                    <br />
                      Choose from our stock images for many popular occasions or upload your own design .</small>
                  </li>
                </ul>
              </Fragment>
              : <Fragment>
                <h3>Login or Create your corporate account</h3>
                <p>
                  <em>
                    The corporate customization suite offers a dramatic,
                    engaging method of delivering a meaningful message
                  </em>
                  to clients about your commitment to charitable giving. You can
                  create eGifts with your unique graphic design or order bulk,
                  custom physical cards.
                  <br />
                  You can even have affinity with specific charitable causes; by
                  selecting a group of charities to highlight on your branded,
                  customized page.
                </p>
                <p>
                  After you login or create a corporate account, you will be
                  able to:
                  <ul>
                    <li>Create your Digital Card with your own graphic.</li>
                    <li>Create your Digital Card with your corporate logo</li>
                    <li>
                      Add your logo to the special occasion Digital Card that
                      you have selected.
                    </li>
                  </ul>
                </p>
                <p>
                  <a href="/Login.aspx?CA=1&ReturnPage=^CorporateSolutions^BrandDigitalCard">
                    <em>Login or Create your corporate account now...</em>
                  </a>
                </p>
              </Fragment>}
          </p>

          <p>
            <em>
              CharityChoice gifts are 100% Tax Deductible!
              <br />
              Over 1000, including 250 major charities from which gift
              recipients may choose.
            </em>
          </p>
        </div>
      </MainPage >
    );
  }
}
